/**
 * Preview i18n Provider
 *
 * Shared UI components (PropPick) call react-i18next's useTranslation()
 * directly, so a hand-rolled context mock is never consulted — without a real
 * i18next instance the components render raw keys ("game.labels.vs").
 *
 * This provider creates an isolated i18next instance (not the global one, so
 * it can't interfere with any future admin-wide i18n) carrying just the keys
 * the previewed components use, with the same values as the frontend's
 * en locale (apps/frontend/src/i18n/locales/en.ts).
 */

import React, { type ReactNode } from 'react';
import i18next from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';

const previewI18n = i18next.createInstance();

void previewI18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  resources: {
    en: {
      translation: {
        game: {
          labels: {
            vs: 'vs',
            yes: 'Yes',
            no: 'No',
          },
        },
        tiebreaker: {
          title: 'Tiebreaker',
        },
      },
    },
  },
});

export const PreviewI18nProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <I18nextProvider i18n={previewI18n}>{children}</I18nextProvider>;
};
